import {
  DELETE_NOTIFICATIONS,
  GET_NOTIFICATIONS_INFO,
  HANDLE_PCP_REQUEST,
  UPDATE_NOTIFICATIONS_STATUS,
  UPDATE_NOTIFICATION_STATE,
} from "../../actions/actionTypes";
export const NOTIFICATIONS_FEATURE_KEY = "notifications";

let initialState = {
  notificationsState: { total_pages: 1 },
  updateState: {},
  pcpRequest: {},
  deletedNotification: {},
};

let notification = (state = initialState, action) => {
  let { type, payload } = action;
  switch (type) {
    case GET_NOTIFICATIONS_INFO:
      return { ...state, notificationsState: payload };
    case UPDATE_NOTIFICATIONS_STATUS:
      return { ...state, updateState: payload };
    case DELETE_NOTIFICATIONS:
      return { ...state, deletedNotification: payload };
    case HANDLE_PCP_REQUEST:
      return { ...state, pcpRequest: payload };
    case UPDATE_NOTIFICATION_STATE:
      return { ...state, notificationsState: { total_pages: 1, results: [] } };
    default:
      return state;
  }
};
export default notification;
